<template>
  <b-modal
    :visible="visible"
    centered
    modal-class="status-update-modal required_edit_sp_modal"
    no-close-on-backdrop
    title="Edit Required Information"
    @change="val => $emit('update:visible', val)"
  >
    <template v-if="isLittleBuddha">
      <b-form-group
        label="Name 1*"
        label-for="h-ri-eu-name1"
      >
        <b-form-input
          id="h-ri-eu-name1"
          v-model="name1"
          class="text-uppercase"
          placeholder="Name 1"
        />
      </b-form-group>
      <b-form-group
        label="Name 2"
        label-for="h-ri-eu-name2"
      >
        <b-form-input
          id="h-ri-eu-name2"
          v-model="name2"
          class="text-uppercase"
          placeholder="Name 2"
        />
      </b-form-group>
      <b-form-group
        label="Name 3"
        label-for="h-ri-eu-name3"
      >
        <b-form-input
          id="h-ri-eu-name3"
          v-model="name3"
          class="text-uppercase"
          placeholder="Name 3"
        />
      </b-form-group>
      <b-form-group
        label="Name 4"
        label-for="h-ri-eu-name4"
      >
        <b-form-input
          id="h-ri-eu-name4"
          v-model="name4"
          class="text-uppercase"
          placeholder="Name 4"
        />
      </b-form-group>
      <b-form-group
        label="Name 5"
        label-for="h-ri-eu-name5"
      >
        <b-form-input
          id="h-ri-eu-name5"
          v-model="name5"
          class="text-uppercase"
          placeholder="Name 5"
        />
      </b-form-group>
      <b-form-group
        label="Name 6"
        label-for="h-ri-eu-name6"
      >
        <b-form-input
          id="h-ri-eu-name6"
          v-model="name6"
          class="text-uppercase"
          placeholder="Name 6"
        />
      </b-form-group>
    </template>

    <b-form-group
      label="Personal Data Consent"
      label-class="required-info-label"
    >
      <b-form-radio-group v-model="personalDataConsentValue">
        <b-form-radio :value="true">
          <span class="required-info-option-text">Yes, I agree</span>
        </b-form-radio>
        <b-form-radio :value="false">
          <span class="required-info-option-text">No, I disagree</span>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <template v-if="!isLittleBuddha">
      <b-form-group
        label="Purchase Declaration"
        label-class="required-info-label"
      >
        <b-form-radio-group v-model="purchaseDeclarationValue">
          <b-form-radio :value="true">
            <span class="required-info-option-text">Yes, I agree</span>
          </b-form-radio>
          <b-form-radio :value="false">
            <span class="required-info-option-text">No, I disagree</span>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group
        label="Agent Self-Purchase Declaration"
        label-class="required-info-label"
      >
        <b-form-radio-group v-model="agentSelfPurchaseValue">
          <b-form-radio :value="true">
            <span class="required-info-option-text">Yes, I agree</span>
          </b-form-radio>
          <b-form-radio :value="false">
            <span class="required-info-option-text">No, I disagree</span>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </template>

    <b-form-group
      label="Marketing Consent"
      label-class="required-info-label"
    >
      <b-form-checkbox v-model="marketingOptOutValue">
        <span class="required-info-option-text">No, I would not like to receive advertising and promotional material from the Group.</span>
      </b-form-checkbox>
    </b-form-group>

    <b-form-group
      v-if="isLittleBuddha"
      label="Worship Period"
      label-for="h-ri-worship-period"
    >
      <flat-pickr
        id="h-ri-worship-period"
        v-model="worshipPeriodRangeValue"
        class="form-control"
        placeholder="Worship Period"
        :config="flatPickrConfig"
      />
    </b-form-group>

    <template #modal-footer="{}">
      <b-button
        variant="flat-primary"
        :disabled="saving"
        @click="$emit('update:visible', false)"
      >
        Cancel
      </b-button>
      <b-button
        variant="success-custom"
        type="button"
        :disabled="!canSave || saving"
        @click="save"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
          size="16"
        />
        <span class="align-middle">Save Changes</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BFormRadioGroup, BFormRadio, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BModal, BFormGroup, BFormInput, BFormRadioGroup, BFormRadio, BFormCheckbox, BButton, flatPickr,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    // Little Buddha has a different Required Information field set - End Users and Worship Period
    // instead of Purchase Declaration/Agent Self-Purchase, which don't apply to it.
    isLittleBuddha: {
      type: Boolean,
      default: false,
    },
    personalDataConsent: {
      type: Boolean,
      default: false,
    },
    purchaseDeclaration: {
      type: Boolean,
      default: false,
    },
    agentSelfPurchase: {
      type: Boolean,
      default: false,
    },
    marketingDataConsent: {
      type: Boolean,
      default: false,
    },
    // Little Buddha only - up to 6 plain names, Name 1 mandatory (see endUserSchema.js).
    names: {
      type: Array,
      default: () => [],
    },
    // Little Buddha only - "DD/MM/YYYY" strings.
    worshipPeriodStart: {
      type: String,
      default: null,
    },
    worshipPeriodEnd: {
      type: String,
      default: null,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      personalDataConsentValue: this.personalDataConsent,
      purchaseDeclarationValue: this.purchaseDeclaration,
      agentSelfPurchaseValue: this.agentSelfPurchase,
      // Checkbox is phrased as an opt-out ("No, I would not like to receive...") - checked means
      // marketingDataConsent: false, unchecked means marketingDataConsent: true. Inverse of the
      // stored field, so it gets flipped both ways at the prop/data boundary.
      marketingOptOutValue: !this.marketingDataConsent,
      name1: this.names[0] || '',
      name2: this.names[1] || '',
      name3: this.names[2] || '',
      name4: this.names[3] || '',
      name5: this.names[4] || '',
      name6: this.names[5] || '',
      worshipPeriodRangeValue: this.worshipPeriodStart && this.worshipPeriodEnd
        ? `${this.worshipPeriodStart} to ${this.worshipPeriodEnd}`
        : null,
      flatPickrConfig: {
        mode: 'range',
        dateFormat: 'd/m/Y',
        disableMobile: true,
      },
    }
  },
  computed: {
    canSave() {
      return this.isLittleBuddha ? !!this.name1 : true
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.personalDataConsentValue = this.personalDataConsent
        this.purchaseDeclarationValue = this.purchaseDeclaration
        this.agentSelfPurchaseValue = this.agentSelfPurchase
        this.marketingOptOutValue = !this.marketingDataConsent
        this.name1 = this.names[0] || ''
        this.name2 = this.names[1] || ''
        this.name3 = this.names[2] || ''
        this.name4 = this.names[3] || ''
        this.name5 = this.names[4] || ''
        this.name6 = this.names[5] || ''
        this.worshipPeriodRangeValue = this.worshipPeriodStart && this.worshipPeriodEnd
          ? `${this.worshipPeriodStart} to ${this.worshipPeriodEnd}`
          : null
      }
    },
  },
  methods: {
    save() {
      const payload = {
        personalDataConsent: this.personalDataConsentValue,
        marketingDataConsent: !this.marketingOptOutValue,
      }
      if (this.isLittleBuddha) {
        payload.names = [this.name1, this.name2, this.name3, this.name4, this.name5, this.name6]
        const [start, end] = (this.worshipPeriodRangeValue || '').split(' to ')
        payload.worshipPeriodStart = start || null
        payload.worshipPeriodEnd = end || null
      } else {
        payload.purchaseDeclaration = this.purchaseDeclarationValue
        payload.agentSelfPurchase = this.agentSelfPurchaseValue
      }
      this.$emit('save', payload)
    },
  },
}
</script>

<style lang="scss" scoped>
// label-class is a prop BFormGroup uses internally to build its own <legend> - that element is
// created inside BFormGroup's render function, so it never carries this component's scope-id and
// a plain scoped selector can't match it at all (not a specificity issue - deep pierces the
// boundary while staying scoped to this component's subtree).
::v-deep .required-info-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0px;
  color: #000000;
}
.required-info-option-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0px;
  color: #333333;
}
</style>
